import React from "react"
import PropTypes from "prop-types"
import { Carousel } from "react-bootstrap"
import Img from "gatsby-image"

import "./carousel.scss"

const WorksCarousel = ({ images, texts, current }) => {
  const carouselItems = texts.map((text, index) =>
    <Carousel.Item key={index}>
      <figure>
        <Img fluid={images[text.index].node.childImageSharp.fluid}
          style={{ margin: '1rem', maxHeight: 'calc(130vh - 4rem)' }}
          imgStyle={{ objectFit: 'contain' }}
        />
        <figcaption>
          <div className="bottom-bar">
            <div className="text">{`${text.main} ${text.sub}`}</div>
            <div className="counter">{index + 1} of {images.length}</div>
          </div>
        </figcaption>
      </figure>
    </Carousel.Item>
  );

  return (
    <Carousel interval={null} indicators={false} defaultActiveIndex={current} slide={false}>
      {carouselItems}
    </Carousel>
  );
}

WorksCarousel.propTypes = {
  images: PropTypes.array.isRequired,
  current: PropTypes.number.isRequired,
}

export default WorksCarousel